import { BusinessServices } from './../../businesses/services/business.services';
import { PropertyObject } from './../../projects/models/projectEdit';
import { User } from './../../projects/models/user';
import { FdvEdit } from './../models/fdvedit';
import { BaseServices } from './../../kuba.services';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { FDVServices } from './fdv.service';
import { FDV } from '../models/fdvlist';
import { TypeOfObject, ChooseObject, Contact } from '../models/fdv';
@Injectable()
export class FdvListResolver {
  constructor(private backend: FDVServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FDV[]> {
    return this.backend.list(BaseServices.BusinessId);
  }
}
@Injectable()
export class FdvEditResolver {
  constructor(private backend: FDVServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FdvEdit[]> {
    return this.backend.getByFDVId(+route.params['id']);
  }
}
@Injectable()
export class FdvMyListResolver {
  constructor(private backend: FDVServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FDV[]> {
    return this.backend.myList(BaseServices.BusinessId, BaseServices.UserId);
  }
}

@Injectable()
export class TypeOfObjectDropDownResolver {
  constructor(private backend: FDVServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FDV[]> {
    return this.backend.getTypeOfObject();
  }
}

@Injectable()
export class ChooseObjectDropDownResolver {
  constructor(private backend: FDVServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FDV[]> {
    return this.backend.list(BaseServices.BusinessId);
  }
}
@Injectable()
export class ContactDropDownResolver {
  constructor(private backend: FDVServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<FDV[]> {
    return this.backend.getUser(BaseServices.BusinessId);
  }
}
@Injectable()
export class UserListResolver {
  constructor(private backend: BusinessServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getUsersByBusiness(BaseServices.BusinessId);
  }
}

@Injectable()
export class FdvFeaturesResolver {
  constructor(private backend: FDVServices) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.backend.getFdvFeatures(BaseServices.BusinessId);
  }
}
